import React from 'react'
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { useLocation } from 'react-router-dom'

// Define libraries as a constant outside the component
const libraries: 'places'[] = ['places']

function MapComponentCerti({ zooms = 7, data = [] }: any) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyD32soTrhrAXzmKQp7rH8NsL8NQMhmdqlY',
    libraries,
  })

  const { pathname } = useLocation()

  // Define newData BEFORE using it
  const newData = data
    .filter((x: any) => x.position?.lat && x.position?.lng)
    .map((x: any, ind: number) => ({
      id: ind,
      name: x.name,
      lat: Number(x.position.lat),
      lng: Number(x.position.lng),
    }))

  const containerStyle = {
    width: '100%',
    height: '100%',
    position: 'relative' as const,
  }

  const mapRef = React.useRef<google.maps.Map | null>(null)

  const onLoad = React.useCallback(
    (map: google.maps.Map) => {
      mapRef.current = map

      // Wait for container to be ready, then center
      setTimeout(() => {
        if (newData.length > 0 && mapRef.current) {
          google.maps.event.trigger(map, 'resize')
          map.setCenter({ lat: newData[0].lat, lng: newData[0].lng })
          map.setZoom(14)
        }
      }, 300)
    },
    [newData]
  )

  if (!isLoaded) return <div>Loading...</div>
  if (loadError) return <div>Error loading maps</div>

  if (newData.length === 0) {
    return <div>No location data available</div>
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={{ lat: newData[0].lat, lng: newData[0].lng }}
        zoom={14}
        onLoad={onLoad}
        options={{
          streetViewControl: false,
          mapTypeControl: true,
          fullscreenControl: true,
          zoomControl: true,
        }}
      >
        {newData.map((location) => (
          <Marker
            key={location.id}
            position={{ lat: location.lat, lng: location.lng }}
            title={location.name}
          />
        ))}
      </GoogleMap>
    </div>
  )
}

export default MapComponentCerti